import React, { useState, useEffect } from "react"
import { promotionsData } from "../../data/PromotionData"
import { useLeaderboard } from "../../data/LeaderboardProviderCQ9"

export default function ModuleCQ9Funalo({ closeModal }) {
  const promoData = promotionsData.find((promo) => promo.title === "CQ9 Funalo")

  const {
    leaderboardData,
    loading,
    getBonusByRank,
    playerPosition,
    loadingBoard,
    masked,
  } = useLeaderboard()

  return (
    <>
      <div className="promotion-module-pop-container">
        <div className="promotion-module-container">
          <button onClick={closeModal} className="promotion-close-btn">
            Close
          </button>

          <div className="promotion-module-main">
            <div className="promotion-leaderboard">
              <div className="promotion-module-banner">
                <img src={promoData.imgSrc} alt="Promotion Banner" />
                <div className="img-overlay"></div>
              </div>

              <div className="king-of-reel-title"></div>

              <table
                className="promotion-module-table"
                style={{ marginTop: 5 }}
              >
                <thead>
                  <tr>
                    <th>Ranking</th>
                    <th>Username</th>
                    <th>Reward (Free Credits)</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        Loading...
                      </td>
                    </tr>
                  ) : leaderboardData.length > 0 ? (
                    leaderboardData.map((row, index) => {
                      const bonusValue = getBonusByRank(row.ranking)
                      const bonusDisplay = bonusValue
                        ? bonusValue.toLocaleString()
                        : "-"

                      return (
                        <tr key={index}>
                          <td>{row.ranking}</td>
                          <td>{row.masked}</td>
                          <td>{bonusDisplay}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="promotion-module-cta">
              <span style={{ fontSize: 13, paddingInline: 10 }}>
                {loadingBoard ? (
                  <p>Loading Leaderboard...</p>
                ) : playerPosition ? (
                  <p>CQ9 Funalo: Rank#{playerPosition}</p>
                ) : (
                  <p>
                    Daily winners will get their rewards{" "}
                    <strong className="highlight">Credited at 3PM.</strong>
                  </p>
                )}
              </span>
              <a href="/slots/?provider=CQ9">
                <button className="promotion-module-leaderboard-btn">
                  Play Now
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
